module.exports = __webpack_public_path__ + "img/30.11f823a9.jpg";